import React from "react";
import { connect } from "react-redux";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FormLabel } from "@mui/material";
import CustomSwitch from "../../components/CustomInput/CustomSwitch";

// core components
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import GridContainer from "../../components/Grid/GridContainer";
import CustomInput from "../../components/CustomInput/CustomInput";
import NumberInput from "../../components/CustomInput/NumberInput";
import SaveButton from "../../components/CustomInput/SaveButton";
import extendedFormsStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle";
import * as actions from "../../store/actions";
import { __ } from "../../translations/utils";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper";
import { toast } from "react-toastify";
import { Navigate } from "react-router";

class Bulk extends React.Component {
  //reference
  form = React.createRef();

  state = {
    saving: false,
    hasError: false,
    start: 1,
    eind: 1,
    usePrefix: false,
    prefix: "",
    useSuffix: false,
    suffix: "",
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ saving: true });

    let data = new FormData(this.form.current);

    axios.post("core/tafels/createbulk", data).then((response) => {
      let text = __("tafels", "response.tafels.create", "[0] Tafels aangemaakt\\n [1] Tafels bestonden al", [
        response.data.data.counts.new,
        response.data.data.counts.bestaanden,
      ]);
      toast.success(text);

      this.setState({ saving: false });
    });
  };

  handleCheckbox = (name) => (event) => {
    let state = { ...this.state };
    state[name] = event.target.checked;
    this.setState(state);
  };

  handleNumberInput = (response) => {
    let state = { ...this.state };
    state[response.name] = response.value;
    this.setState(state);
  };

  fieldHasErrors = (field) => {
    if (this.state.hasError === false) {
      return false;
    } else {
      return this.state.errors[field] !== undefined;
    }
  };

  renderRedirect = () => {
    toast.warn(<TranslationWrapper tDefault={"Selecteer eerst een vestiging"} tKey={"global.error.selectVestiging"} />);

    return <Navigate to={"/manager/tafels"} />;
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <form onSubmit={this.handleSubmit} ref={this.form}>
          {this.props.vestiging_id ? (
            <input name={"vestiging_id"} type={"hidden"} value={this.props.vestiging_id} />
          ) : (
            this.renderRedirect()
          )}
          <GridContainer>
            <GridItem>
              <SaveButton hasError={this.state.hasError} saving={this.state.saving} type={"submit"} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem md={12}>
              <Card>
                <CardBody>
                  <GridContainer>
                    <GridItem md={2} xs={12}>
                      <TranslationWrapper tDefault={"Start reeks"} tKey={"tafels.modal.bulk.form.start"} />
                    </GridItem>
                    <GridItem sm={10} xs={12}>
                      <NumberInput
                        decimalen={0}
                        id={"start"}
                        name={"start"}
                        onChange={this.handleNumberInput}
                        value={this.state.start}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem md={2} xs={12}>
                      <TranslationWrapper tDefault={"Eind reeks"} tKey={"tafels.modal.bulk.form.eind"} />
                    </GridItem>
                    <GridItem sm={10} xs={12}>
                      <NumberInput
                        decimalen={0}
                        id={"eind"}
                        inputProps={{
                          style: { paddingTop: "32px" },
                        }}
                        name={"eind"}
                        onChange={this.handleNumberInput}
                        value={this.state.eind}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem sm={2} xs={6}>
                      <FormLabel className={classes.labelHorizontal} htmlFor={"usePrefix"}>
                        <TranslationWrapper
                          tDefault={"Gebruik andere prefix (default tafel)"}
                          tKey={"tafels" + "." + "modal.bulk.form.usePrefix"}
                        />
                      </FormLabel>
                    </GridItem>
                    <GridItem sm={2} style={{ marginTop: "27px" }} xs={6}>
                      <CustomSwitch
                        checked={this.state.usePrefix}
                        name={"usePrefix"}
                        onChange={this.handleCheckbox("usePrefix")}
                      />
                    </GridItem>
                    {this.state.usePrefix ? (
                      <GridItem sm={8}>
                        <CustomInput
                          error={this.fieldHasErrors("prefix")}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          helperText={this.fieldHasErrors("prefix") ? this.state.errors.prefix : undefined}
                          id={"prefix"}
                          inputProps={{
                            type: "text",
                            name: "prefix",
                          }}
                        />
                      </GridItem>
                    ) : null}
                  </GridContainer>
                  <GridContainer>
                    <GridItem sm={2} xs={6}>
                      <FormLabel className={classes.labelHorizontal} htmlFor={"useSuffix"}>
                        <TranslationWrapper tDefault={"Gebruik suffix"} tKey={"tafels.modal.bulk.form.useSuffix"} />
                      </FormLabel>
                    </GridItem>
                    <GridItem sm={2} style={{ marginTop: "27px" }} xs={6}>
                      <CustomSwitch
                        checked={this.state.useSuffix}
                        name={"useSuffix"}
                        onChange={this.handleCheckbox("useSuffix")}
                      />
                    </GridItem>
                    {this.state.useSuffix ? (
                      <GridItem sm={8}>
                        <CustomInput
                          error={this.fieldHasErrors("suffix")}
                          formControlProps={{
                            fullWidth: true,
                          }}
                          helperText={this.fieldHasErrors("suffix") ? this.state.errors.suffix : undefined}
                          id={"suffix"}
                          inputProps={{
                            type: "text",
                            name: "suffix",
                          }}
                        />
                      </GridItem>
                    ) : null}
                  </GridContainer>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </form>
      </div>
    );
  }
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Bulk, extendedFormsStyle));
